<template>
  <div role="group" class="btn-group dropup">
    <button
      class="btn btn-secondary text-white ps-5 text-nowrap position-relative rounded-pill"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <i class="bi bi-plus-circle-fill position-absolute h4 lh-1 start-0 ms-2"></i>
      Kategorie hinzufügen
    </button>
    <ul class="dropdown-menu" aria-labelledby="addCategoryDropdown">
      <li>
        <span class="dropdown-item cursor-pointer" @click="addCategory('-freetext', menuId)">
          <base-icon-freetext></base-icon-freetext>
          freie Texteingabe
        </span>
      </li>
      <!--<li>
        <span class="dropdown-item cursor-pointer" @click="addCategory('-soft', menuId)">
          <base-icon-softdrinks></base-icon-softdrinks>
          Soft-Getränke
        </span>
      </li>
      <li>
        <span class="dropdown-item cursor-pointer" @click="addCategory('-hard', menuId)">
          <base-icon-harddrinks></base-icon-harddrinks>
          alkoholische Getränke
        </span>
      </li>
      <li>
        <span class="dropdown-item cursor-pointer" @click="addCategory('-food', menuId)">
          <base-icon-food></base-icon-food>
          Speisen
        </span>
      </li>-->
      <!--      <li>-->
      <!--        <span-->
      <!--          class="dropdown-item cursor-pointer"-->
      <!--          @click="addCategory('-default', menuId)"-->
      <!--        >-->
      <!--          <i-->
      <!--            class="bi bi-patch-question-fill"-->
      <!--            style="margin-left: -0.1rem; margin-right: 0.1rem"-->
      <!--          ></i>-->
      <!--          Diverses-->
      <!--        </span>-->
      <!--      </li>-->
      <li>
        <span class="dropdown-item cursor-pointer" @click="addCategory('-combo', menuId)">
          <i class="bi bi-gift-fill" style="margin-left: -0.1rem; margin-right: 0.1rem"></i>
          Kombo-Angebot
        </span>
      </li>
      <li v-if="menu.attributes.data.format != 'SP'">
        <span class="dropdown-item cursor-pointer" @click="addCategory('-filler', menuId)">
          <i class="bi bi-file-earmark-image" style="margin-left: -0.1rem; margin-right: 0.1rem"></i>
          Designseite
        </span>
      </li>
      <li>
        <span class="dropdown-item cursor-pointer" @click="addCategory('-pagebreak', menuId)">
          <base-icon-pagebreak></base-icon-pagebreak>
          Seitenumbruch
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    addCategory: { type: Function, default: null },
    menuId: { type: Number, default: null },
    menu: { type: Object, default: null },
  },
  setup() {},
};
</script>

<style lang="scss" scoped></style>
